import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  nhomChucVuId: [],
  nhomChucVuDangCapNhat: {},
  nhomChucVu: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
